'use client';

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createEditorDataSlice } from './editorDataSlice';
import { createEditorMetaSlice } from './editorMetaSlice';
import { createEditorHistorySlice } from './editorHistorySlice';
import { createEditorActionSlice } from './editorActionSlice';
import { createEditorIndicatorSlice } from './editorIndicatorSlice';
import { createEditorMediaSlice } from './editorMediaSlice';
import { type EditorStore } from './type';

export const usePageEditorStore = create<EditorStore>()(
    devtools((...args) => ({
        ...createEditorDataSlice(...args),
        ...createEditorMetaSlice(...args),
        ...createEditorHistorySlice(...args),
        ...createEditorActionSlice(...args),
        ...createEditorIndicatorSlice(...args),
        ...createEditorMediaSlice(...args),
    }))
);

export type UsePageEditorStoreReturn = ReturnType<typeof usePageEditorStore>;
